<template>
  <div>
    <div v-if="userid === -1 || data === null">
      <LoadingPage />
    </div>
    <div v-if="data !== null" style="margin: 10px;">
      <van-nav-bar
        left-text="返回"
        :title="data.student"
        @click-left="$router.go(-1)"
      ></van-nav-bar>
      <div style="color: red">
        要减少需要缴纳的定金，请一定填写负数，正数会增加需缴纳定金数额
      </div>
      <van-list>
        <div
          v-for="item in packageList"
          :key="item.package_id"
          class="package-item"
        >
          <van-cell :title="item.package_name" class="title-cell" />
          <van-cell>
            <template #title>
              调整定金
            </template>
            <template #value>
              <van-field
                v-model.number="item.value"
                type="number"
                placeholder="请输入新的值"
                class="editable-field"
              />
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              备注
            </template>
            <template #value>
              <van-field
                v-model="item.note"
                placeholder="请输入备注"
                class="editable-field"
              />
            </template>
          </van-cell>
        </div>
      </van-list>
      <van-button type="info" block @click="submitAll">提交更改</van-button>
      <div style="color: red" v-if="this.data.earnest_status === 'PD'">
        注意，当前用户的定金是已支付状态，请谨慎调整
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, List, Cell, Field, Button } from "vant";
import { Notify } from "vant";
import LoadingPage from "../../components/LoadingPage";
import { mapActions, mapState } from "vuex";
import { getCourseInfoAdjustEarnest } from "../../services/user";
import { modify_adjust_earnest } from "../../services/admin";
import { warningNotify } from "@/utils/notify";

export default {
  name: "earnestAdjustment",
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    LoadingPage
  },

  data() {
    return {
      data: null
    };
  },
  computed: {
    ...mapState({
      token: state => state.users.token,
      userid: state => state.users.userid
    }),
    packageList() {
      if (this.data === null) {
        return [];
      }
      return this.data.adjust;
    }
  },
  methods: {
    ...mapActions({ tokenChecker: "users_tokenChecker" }),
    submitAll() {
      console.log("Submitting all data:", this.packageList);
      let payload = {
        course_info_id: this.data.course_info_id,
        adjust: this.packageList
      };
      modify_adjust_earnest(this.token, payload).then(result => {
        if (!result.status) {
          warningNotify("提交数据失败！");
          return;
        }
        console.log(result);
        Notify({ type: "success", message: "定金已调整", duration: 3000 });
      });
    },
    getAdjustEarnest() {
      if (this.token === "") {
        return;
      }
      let infoId = this.$route.params.id;
      getCourseInfoAdjustEarnest(this.token, infoId).then(result => {
        if (!result.status) {
          warningNotify("获取数据失败！");
          return;
        }
        this.data = result.data;
        this.isDataGot = true;
      });
    }
  },
  beforeMount() {
    // 应该在每个登录才能操作的视图加上下面这句
    this.tokenChecker();
    this.$store.state.system.tabBarActive = "user";
    if (this.data === null) {
      this.getAdjustEarnest();
    }
  },
  updated() {
    if (this.data === null) {
      this.getAdjustEarnest();
    }
  }
};
</script>

<style scoped>
.title-cell {
  background-color: #f0f0f0;
}

.editable-field {
  background-color: #fff;
}
</style>
